"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHandler = void 0;
const messages_1 = require("./messages");
const getHandler = (service) => {
    return (env, msg) => {
        switch (msg.constructor) {
            case messages_1.SetPersistentMemoryMsg:
                return handleSetPersistentMemoryMsg(service)(env, msg);
            case messages_1.GetPersistentMemoryMsg:
                return service.get();
            default:
                throw new Error("Unknown msg type");
        }
    };
};
exports.getHandler = getHandler;
const handleSetPersistentMemoryMsg = (service) => (_, msg) => {
    service.set(msg.data);
    return {
        success: true,
    };
};
//# sourceMappingURL=handler.js.map